<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>

	<form @submit.prevent="shouldSubmit">
		<c-card>
			<h3 slot="title" color="green">{{ $t("pages.orderForm.companyDetails") }}</h3>
			<row>
				<v-col cols="9">
					<cols-row md="6">
						<clients-select :required="true" :clearable="false" v-if="!authIsClient"
							v-model="form.project.client_id"/>
						<branches-select :required="true" v-if="form.project.client_id" lazy="client_id"
							ref="brachInput" :filters="{client_id: form.project.client_id}"
							v-model="form.project.branch_id"/>
					</cols-row>
					<cols-row md="4">
						<smart-input :error="inputErrors.designer" :label="$t('pages.orderTable.designer')"
							v-model="form.designer"></smart-input>
						<smart-input type="tel" :error="inputErrors.designer_phone"
							:label="$t('pages.orderTable.designerPhone')"
							v-model="form.designer_phone" :pattern="phonePattern" placeholder="05x-xxxxxxx or 0x-xxxxxxx"></smart-input>
						<smart-input type="email" :error="inputErrors.designer_email"
							:label="$t('pages.orderTable.designer') + '  ' + $t('attributes.email')"
							v-model="form.designer_email"></smart-input>
					</cols-row>
				</v-col>
				<v-col v-if="form.project.branch_id">
					<branch-card :branch-id="form.project.branch_id"></branch-card>
				</v-col>
			</row>
		</c-card>
		<c-card>
			<h3 slot="title" color="green">{{ $t("pages.orderForm.customerDetails") }}</h3>
			<cols-row md="4">
				<smart-input required :error="inputErrors.customer" :label="$t('attributes.customerName')"
					v-model="form.customer"></smart-input>
				<smart-input :error="inputErrors.order_num" :label="$t('pages.orderTable.orderNum')"
					v-model="form.order_num"></smart-input>
				<smart-input type="checkbox" :error="inputErrors.order_num" label="הזמנה דחופה"
					v-model="form.urgent"></smart-input>
				<!--				<recheck-select v-model="form.recheck" v-cant="['client']"></recheck-select>-->
			</cols-row>
			<cols-row md="6">
				<smart-input required :error="inputErrors.customer_phone" :label="$t('pages.orderTable.tel')"
					v-model="form.customer_phone" :pattern="phonePattern" placeholder="05x-xxxxxxx or 0x-xxxxxxx"></smart-input>

        <smart-input :error="inputErrors.note" :label="$t('pages.projectForm.contact')"
					v-model="form.contact_name"></smart-input>
			</cols-row>
			<cols-row md="6" cols="12">
				<smart-input :error="inputErrors.tel2" :label="$t('pages.orderTable.tel2')"
					v-model="form.tel2" :pattern="phonePattern" placeholder="05x-xxxxxxx or 0x-xxxxxxx"></smart-input>
				<smart-input :error="inputErrors.contact_tel2"
					:label="$t('pages.orderConsForm.secondContact')"
					v-model="form.contact2_tel"
				></smart-input>
				<smart-input required :error="inputErrors.address" :label="$t('pages.orderForm.measurementAddress')"
					v-model="form.project.address"></smart-input>
				<cites-select v-model="form.project.city" required/>
				<smart-input required :error="inputErrors.building" :label="$t('pages.orderForm.building')"
					v-model="form.building"></smart-input>
				<smart-input :error="inputErrors.entrance" :label="$t('pages.orderForm.entrance')"
					v-model="form.entrance"></smart-input>
				<smart-input :error="inputErrors.apartment_floor" required :label="$t('pages.orderForm.floor')"
					v-model="form.apartment_floor"></smart-input>
				<smart-input required :error="inputErrors.apartment_num" :label="$t('pages.orderForm.apartmentNum')"
					v-model="form.apartment_num"></smart-input>
			</cols-row>
		</c-card>
		<c-card>
			<h3 slot="title" color="green">{{ $t("pages.orderForm.mesurementDetails") }}</h3>
			<measurement-form @remove="removeMeasurement(m)" :removedFiles="removedFIles" :measurement="m"
				v-for="m in measurementsWithFiles"
				:key="m.id"/>
			<v-btn class="primary" text @click="addMeasurement()">
				<v-icon circle>add</v-icon>
				{{ $t("pages.orderForm.anotherOrder") }}
			</v-btn>
		</c-card>
		<cols-row cols="6" :row="{justify:'center'}">
			<btn-loader :progress="inProgress"></btn-loader>
		</cols-row>
	</form>
</template>


<script>

	import OrderModule from "src/store/modules/Order.module";
	import FormView from "src/mixins/FormView";
	import CCard from "dev/scaffoldings/cCard";
	import BranchesSelect from "dev/view/branches/BranchesSelect";
	import ClientsSelect from "dev/view/clients/ClientsSelect";
	import BtnLoader from "dev/components/BtnLoader";
	import MeasurementForm from "dev/view/measurements/MeasurementForm";
	import uniqueId from "lodash/uniqueId";
	import BranchCard from "dev/view/branches/BranchCard";
	import CitesSelect from "dev/view/measurements/CitesSelect";

	export default {
		props: {currentMeasurement: Object},
		name: "order-form",
		components: {
			CitesSelect,
			BranchCard, MeasurementForm, BtnLoader, ClientsSelect, BranchesSelect, CCard
		},
		data() {
			return {
				form: {
					name: null,
				},
				phonePattern: "^[0-9]{2,3}-[0-9]{7}",
				project: {},
				measurements: [],
				removedFIles: [],
				branch: null,
				inProgress: false

			};
		},
		mixins: [new FormView(OrderModule, "order", true)],
		computed: {

			isNew() {
				return !!this.order.id;
			},
			branchFilter() {
				return this.form.branch_id;
			},
			auth() {
				return this.$store.state.AuthModule.user;
			},
			authIsClient() {
				return this.$store.getters.isClient;
			},
      selectedBranch() {
				if (!this.$refs.brachInput) return null;
				return this.$refs.brachInput.objectValue;
			},
			measurementsToShow() {
				if (this.currentMeasurement) {
					return this.measurements.filter((m) => {
						return m.id == this.currentMeasurement.id ||
							(isNaN(m.id) && m.id.indexOf("notreal") == 0);
					});
				}
				return this.measurements;
			},
			measurementsWithFiles() {
				let measurementsToShow = this.measurementsToShow;

				if (this.currentMeasurement) {
					measurementsToShow.forEach((item) => {
						if (this.currentMeasurement.id === item.id) {
							item.files = this.currentMeasurement.files;
						}
					});
				}
				return measurementsToShow;
			}
		}, methods: {
			async shouldSubmit(e) {
				if (this.authIsClient && !this.form.project.branch_id) {
					swal.fire('בחר סניף!');
					return;
				}
				try {
					this.inProgress = true;
					await this.onSubmit(e);
					this.inProgress = false;
				} catch (e) {
					this.inProgress = false;
				}
			},
			beforeSubmit(formData) {
				let data = Object.assign({}, this.form, {
					measurements: this.measurements,
					removedFiles: this.removedFIles
				});
				formData.append("order", JSON.stringify(data));
				this.measurements.forEach(measurement => {
					if (measurement.files) {
						measurement.files.forEach((f, x) => {
							if (!f.id) {
								formData.append(`files-${measurement.id}[]`, f);
							}
						});
					}
				});
				return formData;
			},
			removeMeasurement(m) {
				let index = this.measurements.indexOf(m);
				if (index > -1) {
					this.measurements.splice(index, 1);
				}
			},
			addMeasurement() {
				this.measurements.push({
					id: uniqueId("notreal"),
					files: []
				});
			}
		},
		created() {
			if (this.auth.client_id) {
				this.form.project.client_id = this.auth.client_id;
			}
			if (!(this.form.measurements && this.form.measurements.length)) {
				this.addMeasurement();
			}
		},
		watch: {
			"form.project.client_id"() {
				this.form.project.branch_id = null;
			},
			"form.measurements": {
				handler() {
					if (this.form.measurements && this.form.measurements.length) {
						this.measurements = this.form.measurements.slice(0);
					} else {
						this.measurements = this.form.measurements;
					}
				},
				immediate: true
			}
		}
	};
</script>
